import { BinList } from "../BinType/state";

export interface BinGroupInterface {
    newBinGroup:newBinGroupInterface 
    originalBinGroup:SelectedBinListInBinGroup[]|null
    selectedBinInBinGroup:SelectedBinListInBinGroup[]|null
}
export type SelectedBinListInBinGroup = Pick<BinList, 
    'bin_id' | 
    'code' | 
    'toilet_number' | 
    'location_cn' | 
    'bin_group_sequence'|
    'label'|
    'value'
>;


export interface newBinGroupInterface{
    group_name_tc:string
    group_name_en:string   
    is_active:number
    bin_group_id?:number
    created_date?:string,
    updated_date?:string,
    created_by?:number,
    updated_by?:number
}

export const binGroupListState: BinGroupInterface = {
    selectedBinInBinGroup:[],
    originalBinGroup:[],
    newBinGroup:{
group_name_tc:'',
group_name_en:'',
is_active:1
    }
}

export type AddBinFormInterface = keyof Pick<newBinGroupInterface, 'group_name_tc' | 'group_name_en'>;

